function upsizeProductImage(product) {
    const image = product.find('.image img')

    const currentSrc = image.attr('src')

    // Only replace if the URL contains '/detail/'
    //   if (currentSrc && currentSrc.includes('/detail/')) {
    const newSrc = currentSrc.replace('/detail/', '/orig/')
    console.log(newSrc)

    image.attr('src', newSrc)

    if (image.attr('data-src')) {
        image.attr('data-src', image.attr('data-src').replace('/detail/', '/orig/'))
    }
    if (image.attr('data-next')) {
        image.attr('data-next', image.attr('data-next').replace('/detail/', '/orig/'))
    }
}

export const transformProducts = () => {
    const products = $('.products:not(#productsTop) .product')

    if (products.length) {
        products.each(function () {
            const product = $(this)

            upsizeProductImage(product)
        })
    }
}

export function initProducts() {
    transformProducts()

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        transformProducts()
    })
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        transformProducts()
    })
}
